import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const errors = {
	state: {
		totales: '',
		validaciones: [],
		estadosValidacion: {},
		tutoradas: [],
		practicasJE: [],
		documentos: [],
		aprobaciones: [],
		loading: false
	},
	getters: {
		getTotales: state => state.totales,
		getValidaciones: state => state.validaciones,
		getAprobaciones: state => state.aprobaciones,
		getTutoradas: state => state.tutoradas,
		getPracticasJE: state => state.practicasJE,
		getTutoradasPorEstados: state => {
			let tutoradas = new Object();
			if (state.tutoradas.length > 0) {
				tutoradas['en-curso'] = state.tutoradas.filter(e => e.evaluadaPorTutor == null);
				tutoradas['en-evaluacion'] = state.tutoradas.filter(e => e.evaluadaPorTutor == false);
				tutoradas['evaluados'] = state.tutoradas.filter(e => e.evaluadaPorTutor == true);
			}
			return tutoradas;
		},

		getTutoradas: state => state.tutoradas,
		getValidacionesPorEstados: state => {
			let validaciones = new Object();
			if (state.validaciones.length > 0) {
				validaciones['pendientes'] = state.validaciones.filter(e => e.idEstadoValidacion == 1);
				validaciones['validadas'] = state.validaciones.filter(e => e.idEstadoValidacion == 2);
				validaciones['rechazadas'] = state.validaciones.filter(e => e.idEstadoValidacion == 3);
			}
			return validaciones;
		},
		getAprobacionesPorEstados: state => {
			let aprobaciones = new Object();
			if (state.aprobaciones.length > 0) {
				aprobaciones['pendientes'] = state.aprobaciones.filter(e => e.algunaTitulacionPendienteValidar);
				aprobaciones['aprobadas'] = state.aprobaciones.filter(e => e.algunaTitulacionValidada);
				aprobaciones['denegadas'] = state.aprobaciones.filter(e => e.algunaTitulacionRechazada);
			}
			return aprobaciones;
		},
		getPracticasJePorEstados: state => {
			let practicasJE = new Object();
			if (state.practicasJE.length > 0) {
				practicasJE['pendientes'] = state.practicasJE.filter(e => e.idEstadoValidacion == 1);
				practicasJE['validadas'] = state.practicasJE.filter(e => e.idEstadoValidacion == 2);
				practicasJE['rechazadas'] = state.practicasJE.filter(e => e.idEstadoValidacion == 3);
			}
			return practicasJE;

		},
		getDocumentos: state => state.documentos,
		getLoading: (state) => {
			return state.loading;
		}

	},
	actions: {
		requestTotales: ({ commit, dispatch }) => {

			if (!!axios.defaults.headers.get.authorization) {

				return new Promise((resolve, reject) => {
					axios.get('/api/TutorAcademico/dameTotales').then(response => {
						if (response.data.status == 0) {
							commit('setTotales', response.data.datos);
							resolve(true);
						} else {
							commit('setError', response.data.status);
						}
					})
						.catch(function (error) {
							reject(false);
							dispatch('sendErrorServer', error.response);
						});
				});

			}
		},
		requestValidaciones: ({ commit, dispatch }) => {

			return new Promise((resolve, reject) => {
				axios.get('/api/TutorAcademico/damePracticasAvalidar').then(response => {
					if (response.data.status == 0) {
						if (!!response.data.datos) {
							commit('setValidaciones', response.data.datos);
						}
						resolve(true);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestEstadosValidacion: ({ commit, dispatch }) => {

			return new Promise((resolve, reject) => {
				axios.get('/api/Dominios/estadosValidacionPracticas').then(response => {
					if (response.data.status == 0) {
						commit('setEstadosValidacion', response.data.datos);
						resolve(true);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestTutoradas: ({ commit, dispatch }) => {
			commit('loading')
			return new Promise((resolve, reject) => {
				axios.get('/api/TutorAcademico/damePracticasTutoradas').then(response => {
					if (response.data.status == 0) {
						if (!!response.data.datos) {
							commit('setTutoradas', response.data.datos);
						}
						resolve(true);
					} else {
						commit('setError', response.data.status);
					}
					commit('endLoad')
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestTutoradasHistorico: ({ commit, dispatch }, idAnioAcademico) => {
			commit('loading')
			return new Promise((resolve, reject) => {
				axios.get('/api/TutorAcademico/damePracticasTutoradasPorAnio/' + idAnioAcademico).then(response => {
					if (response.data.status == 0) {
						commit('setTutoradas', response.data.datos);
						resolve(true);
					} else {
						commit('setError', response.data.status);
					}
					commit('endLoad')
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestPractica: ({ commit, dispatch }, id) => {

			const token = window.localStorage.getItem("_token");
			axios.defaults.headers.get['authorization'] = `Bearer ${token}`;

			return new Promise((resolve, reject) => {

				axios.get('/api/TutorAcademico/dameDetallePractica/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestAprobaciones: ({ commit, getters, dispatch }) => {
			axios.get(`/api/TutorAcademico/dameOfertasAsignadasParaValidacion`).then(response => {
				(response.data.status == 0) ? commit('setAprobaciones', response.data.datos) : '';
			})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
		},
		requestJefeEstudios: ({ state, commit, dispatch }) => {
			commit('loading')
			axios.get(`/api/TutorAcademico/damePracticasDeTitulacionesJefeEstudios`).then(response => {
				if (response.data.status == 0) {
					state.practicasJE = response.data.datos
				}
				commit('endLoad')
			}).catch(function (error) {
				commit('setError', 500);
				dispatch('sendErrorServer', error.response);
			});
		},
		requestAprobacion: ({ commit, dispatch }, id) => {

			const token = window.localStorage.getItem("_token");
			axios.defaults.headers.get['authorization'] = `Bearer ${token}`;

			return new Promise((resolve, reject) => {

				axios.get('/api/TutorAcademico/dameOfertaAsignadaParaValidacion/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestDocumentos: ({ commit, getters, dispatch }) => {
			axios.get(`/api/Dominios/tiposDocumentoAlumnoPracticas`).then(response => {
				(response.data.status == 0) ? commit('setDocumentos', response.data.datos) : '';
			})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
		},
		cambiaEstadoPractica: ({ commit, dispatch }, data) => {

			if (!!!data.fichero.ficheroB64) {
				data.fichero = null;
			}

			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/cambiaEstadoPractica', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 502);
						commit('changePracticaStatus', data);
						resolve(true);
						dispatch('requestTotales');
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		marcarEvaluada({ commit, dispatch }, id) {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/marcarComoEvaluada/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setError', 501);
						commit('changeEvaluacion', id);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		cambiarEstadoAprobacion({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/cambiarEstadoAprobacionOfertaAsignadaParaValidacion/', data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setError', 506);
						dispatch('requestAprobaciones');
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		marcarEvaluacionPendiente({ commit, dispatch }, id) {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/marcarComoEvaluacionPendiente/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setError', 503);
						commit('changeEvaluacion', id);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		dameContestacionEncuesta({ commit, dispatch }, id) {
			return new Promise((resolve, reject) => {
				axios.get('/api/TutorAcademico/dameContestacionEncuenstaPracticas/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		addDocumentoPractica({ commit }, data) {

			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/' + data.type, data.request).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						reject(false);
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestCertificadoPracticasTutorizadas({ commit, dispatch }, idAnioAcademico) {
			return new Promise((resolve, reject) => {
				let url = '/api/TutorAcademico/dameCertificadoPracticasTutorizadas/';
				if (idAnioAcademico) {
					url += `?idAnioAcademico=${idAnioAcademico}`;
				}
				axios.get(url).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						commit('setError', response.data.status);
						resolve(false);
					}
				}).catch(function (error) {
					reject(false);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		requestTutoresParaEstudio({ commit }, id) {

			return new Promise((resolve, reject) => {
				axios.get(`/api/TutorAcademico/dameTutoresAcademicosParaElEstudio/${id}`).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						commit('setError', response.data.status);
					}
				}).catch(function (error) {
					reject(false);
					dispatch('sendErrorServer', error.response);
				});
			});
		}
	},
	mutations: {
		setTotales: function (state, totales) {
			state.totales = totales
		},
		setValidaciones: function (state, practicas) {
			state.validaciones = practicas
		},
		setEstadosValidacion: function (state, estados) {
			state.estadosValidacion = estados
		},
		setTutoradas: function (state, practicas) {
			if (practicas) {
				state.tutoradas = practicas
			}else{
				state.tutoradas = []
			}
		},
		setDocumentos: function (state, data) {
			state.documentos = data;
		},
		setAprobaciones: function (state, data) {
			state.aprobaciones = data;
		},
		changePracticaStatus: function (state, data) {
			state.validaciones.forEach(e => {
				if (e.idPractica == data.idPractica) {
					e.idEstadoValidacion = data.idEstado;
				}
			});
		},
		changeEvaluacion: function (state, id) {
			state.tutoradas.forEach(e => {
				if (e.idPractica == id) {
					e.evaluadaPorTutor = !e.evaluadaPorTutor;
				}
			});
		},
		setLoading(state, st) {
			state.loading = st;
		},
		loading(state) {
			state.loading = true;
		},
		endLoad(state) {
			state.loading = false;
		},

	}
}

export default errors;



// WEBPACK FOOTER //
// ./src/store/practicas.js